import React, { useState, useEffect } from "react";
import { eventsApi } from "../services/api";
import EventCard from "../components/EventCard";

function Events() {
  const [events, setEvents] = useState([]);
  const [search, setSearch] = useState("");
  const [typeFilter, setTypeFilter] = useState("");
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    eventsApi.list({ public: "true" })
      .then(data => setEvents(Array.isArray(data) ? data.filter(e => e.status !== "archived") : []))
      .catch(() => setEvents([]))
      .finally(() => setLoading(false));
  }, []);

  const filtered = events.filter(e => {
    const matchSearch = !search || e.title?.toLowerCase().includes(search.toLowerCase()) || e.location?.toLowerCase().includes(search.toLowerCase());
    const matchType = !typeFilter || e.eventType === typeFilter;
    return matchSearch && matchType;
  });

  return (
    <section className="events-section container" style={{ paddingTop: "48px" }}>
      <h2>All Events</h2>
      <p style={{ color: "var(--text-secondary)", marginBottom: "28px" }}>Browse and filter available comp'd experiences</p>

      <div className="filter-bar">
        <input
          type="text"
          placeholder="Search events or locations..."
          value={search}
          onChange={e => setSearch(e.target.value)}
          aria-label="Search events"
        />
        <select
          value={typeFilter}
          onChange={e => setTypeFilter(e.target.value)}
          aria-label="Filter by event type"
        >
          <option value="">All Types</option>
          <option value="cruise">Cruises</option>
          <option value="resort">Resorts</option>
          <option value="short-notice">Short Notice</option>
          <option value="meetup">Meetups</option>
        </select>
      </div>

      {loading ? (
        <p style={{ color: "var(--text-light)", padding: "40px 0" }}>Loading...</p>
      ) : filtered.length === 0 ? (
        <p style={{ color: "var(--text-light)", padding: "40px 0" }}>No events found matching your criteria.</p>
      ) : (
        <div className="events-grid">
          {filtered.map(event => (
            <EventCard key={event.eventId} event={event} />
          ))}
        </div>
      )}
    </section>
  );
}

function getSampleEvents() {
  return [
    {
      eventId: "sample-1", title: "Caribbean Casino Cruise",
      description: "7-night luxury cruise with complimentary casino play, fine dining, and entertainment.",
      eventType: "cruise", location: "Miami, FL", startDate: "2026-06-15",
      imageUrl: "https://images.unsplash.com/photo-1548574505-5e239809ee19?w=600",
      images: [
        { url: "https://images.unsplash.com/photo-1548574505-5e239809ee19?w=600", caption: "Cruise ship" },
        { url: "https://images.unsplash.com/photo-1544551763-46a013bb70d5?w=600", caption: "Casino" },
      ],
      links: [{ url: "#", label: "Itinerary" }],
    },
    {
      eventId: "sample-2", title: "Vegas VIP Resort Weekend",
      description: "All-inclusive weekend at a premier Las Vegas resort with comp'd room and meals.",
      eventType: "resort", location: "Las Vegas, NV", startDate: "2026-07-10",
      imageUrl: "https://images.unsplash.com/photo-1605833556294-ea5c7a74f57d?w=600",
      images: [{ url: "https://images.unsplash.com/photo-1605833556294-ea5c7a74f57d?w=600", caption: "Vegas" }],
      links: [{ url: "#", label: "Resort Website" }],
    },
    {
      eventId: "sample-3", title: "Atlantic City Flash Deal",
      description: "Last-minute comp'd stay at Borgata. 2 nights, meals, and $200 free play.",
      eventType: "short-notice", location: "Atlantic City, NJ", startDate: "2026-05-01",
      imageUrl: "", images: [], links: [],
    },
    {
      eventId: "sample-4", title: "High Roller Meetup — Biloxi",
      description: "Exclusive networking event for casino enthusiasts with comp'd dinner.",
      eventType: "meetup", location: "Biloxi, MS", startDate: "2026-08-20",
      imageUrl: "https://images.unsplash.com/photo-1511882150382-421056c89033?w=600",
      images: [{ url: "https://images.unsplash.com/photo-1511882150382-421056c89033?w=600", caption: "Casino" }],
      links: [],
    },
  ];
}

export default Events;
